// extracted by mini-css-extract-plugin
module.exports = {"ui_text_color":"TextColor_ui_text_color__1OLD1"};